<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="cancelSubLicence"
      class="modal fade"
      :class="{ show: modalState.show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("renew-subscription") }}
            </h5>

            <NotifcationBox :mssg="this.subMsg" :errorMssg="this.SubErrMsg" />

            <p>
              {{ $t("choose-license-apply") }}
            </p>
            <br />
            <div v-for="licence in activeLicences" :key="licence.key">
              <div class="d-flex align-items-center mb-3">
                <input
                  type="radio"
                  :id="licence.key"
                  class="mr-2"
                  :value="licence.key"
                  v-model="key"
                />

                <label
                  class="mb-0 ml-1"
                  :for="licence.key"
                  style="color:#404A57;font-weight:100"
                >
                  {{ `${licence.devices} x ${licence.key} (${licence.units})` }}
                </label>
              </div>
            </div>
            <div
              class="form-group mt-5"
              style="display:flex; justify-content: space-between"
            >
              <button @click="onCancel" type="button" class="btn btn-secondary">
                {{ $t("cancel") }}
              </button>
              <button
                type="button"
                @click="handleSubmit"
                class="btn btn-primary"
                :disabled="key === ''"
              >
                {{ $t("apply") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import NotifcationBox from "../../components/NotificationBox.vue";

export default {
  name: "RenewSub",
  props: {
    modalState: Object,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      fullname: "",
      email: "",
      role: "staff",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
      key: "",
    };
  },
  components: {
    Loading,
    NotifcationBox,
  },
  mounted() {
    this.fetchActiveLicense().then(() => {
      this.isLoading = false;
    });
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["activeLicences", "subMsg", "SubErrMsg"]),
  },
  methods: {
    ...mapActions([
      "getActiveSubscribedDevices",
      "updateSucMsg",
      "updateErrMsg",
      "fetchActiveLicense",
      "renewSub",
    ]),
    onCancel() {
      this.$emit("closeRenewModal");
    },
    handleSubmit() {
      this.isLoading = true;
      this.renewSub({
        device: this.modalState.deviceTag,
        license: this.key,
      })
        .then((res) => {
          this.isLoading = false;
          this.updateSucMsg(
            res.data.message[0].toUpperCase() + res.data.message.slice(1)
          );
          setTimeout(() => {
            this.updateSucMsg("");
          }, 3000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.updateErrMsg(
            error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1)
          );
          setTimeout(() => {
            this.updateErrMsg("");
          }, 3000);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
  //   watch: {
  //     fullname: {
  //       handler() {
  //         if (/^[a-zA-Z\s]*$/.test(this.fullname))
  //           return (this.selectNotification = "");
  //         else this.selectNotification = this.$t("must_contain");
  //       },
  //     },
  //   },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
button:focus {
  outline: none;
  border: none;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"apply": "Apply",
		"choose-license-apply": "Choose license to apply to your device subscription:",
		"edit_user": "Edit User",
		"email": "Email",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"phone": "Phone Number",
		"renew-subscription": "Renew Subscription",
		"staff": "Staff",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"apply": "appliquer",
		"choose-license-apply": "Choisissez la licence à appliquer à l'abonnement de votre appareil :",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"phone": "Numéro de téléphone",
		"renew-subscription": "Renouveler l'abonnement",
		"staff": "Personnel",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"apply": "Omba",
		"choose-license-apply": "Chagua leseni ya kutuma maombi kwa usajili wa kifaa chako:",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"phone": "Nambari ya simu",
		"renew-subscription": "Sasisha usajili",
		"staff": "STAFF",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi"
	}
}
</i18n>
